import { Injectable, signal } from '@angular/core';
import { LiveBet } from '@models/live-bet.interface';
import { SocketService } from '@shared/socket.service';

/** Buffer size. The feed is kept newest-first, so trimming the tail always drops the oldest bet. */
const MAX_LIVE_BETS = 200;

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  liveBets = signal<LiveBet[]>([]);

  constructor(private socketService: SocketService) {
    this.socketService.socket.on('load_live_bets', (data: LiveBet[]) => {
      const bets = Array.isArray(data) ? [...data] : [];
      bets.sort((a, b) => b.time - a.time);
      this.liveBets.set(bets.slice(0, MAX_LIVE_BETS));
    });

    this.socketService.socket.on('add_live_bet', (data: LiveBet) => {
      this.liveBets.update((bets) => [data, ...bets].slice(0, MAX_LIVE_BETS));
    });
  }
}
